import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import { enqueueSnackbar } from "notistack";
import enqueueError from "utils/enqueueError";
import { useMatchPhaseMutation } from "graphql/types/graphql";
import { MatcherView, PhaseData, useMatcher } from "utils/MatcherProvider";
import { List, ListItem, styled } from "@mui/material";
import MDButton from "components/MDButton";
import { useContext, useEffect } from "react";
import { context } from "utils/Provider";
import { useNavigate } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import { Title } from "../styles/Title";
import buttonBackground from "../../../../assets/images/cruxy-abstract-button.webp";

export function Preview() {
  const navigate = useNavigate();
  const { setIsLoading, selectedCube } = useContext(context);
  const { phaseData, setPhaseData, setPhaseHistory, changeView } = useMatcher();

  const [match, { data, loading, error }] = useMatchPhaseMutation({
    update: (cache, { data }) => {
      if (data?.matchPhase?.success) {
        cache.evict({ id: "ROOT_QUERY", fieldName: "queryMatchedViewsPhaseData" });
        cache.gc();
      }
    },
    onCompleted: (data) => {
      const phase: PhaseData = {
        ...phaseData,
        matchedCount: data.matchPhase.statistics.matchedCount,
        duplicateCount: data.matchPhase.statistics.duplicateCount,
        totalRecords: data.matchPhase.statistics.totalRecords,
        duplicates: data.matchPhase.statistics.duplicates,
      };
      setPhaseData(phase);

      setPhaseHistory((current) => [...current, phase]);

      enqueueSnackbar("Tables matched successfully", { variant: "success" });
      changeView(MatcherView.RESULTS);
    },
    onError: (error) => {
      enqueueError(error);
    },
  });

  const handleMatchPhases = async () => {
    setIsLoading(true);
    try {
      await match({
        variables: {
          cubeId: selectedCube.cubeId,
          phase: 0,
          tableName: phaseData.tableName,
          matcherTable: phaseData.matcherTable,
          identifier: phaseData.identifier,
          headers: phaseData.headers,
        },
      });
    } catch (error: any) {
      enqueueSnackbar(`Error matching tables ${error.message}`, { variant: "error", autoHideDuration: 5000 });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <MDTypography mb="2rem" variant="h3">
        Phase Preview
      </MDTypography>
      <MDBox>
        <MDTypography>
          <Title>Table name:</Title> {phaseData.tableName}
        </MDTypography>
        <MDTypography>
          <Title>Matcher table:</Title> {phaseData.matcherTable}
        </MDTypography>
        <MDTypography>
          <Title>Columns to match:</Title>
        </MDTypography>
        <List
          sx={{
            padding: "0rem 2rem",
            marginBottom: "3rem",
          }}
        >
          {phaseData.headers?.map((header, index) => (
            <ListItem key={index}>
              <MDTypography>
                {index + 1}. {header[1]} -&gt; {header[0]}
              </MDTypography>
            </ListItem>
          ))}
        </List>
        <MDButton
          loading={loading}
          variant="background"
          sx={{
            maxWidth: "200px",
            borderRadius: "8px",
          }}
          onClick={() => handleMatchPhases()}
        >
          Start Matching
        </MDButton>
      </MDBox>
    </>
  );
}
